(function () {
  function boot() {
    document.querySelectorAll('[id^="MainProduct-"]').forEach(function (root) {
      if (root.dataset.hdyProductUx) return;
      root.dataset.hdyProductUx = 'true';
      var sticky = root.querySelector('.hdy-sticky-purchase');
      var action = sticky && sticky.querySelector('button');
      if (!action) return;
      var back = null, toggle = null, backExpanded = false, queued = false, recoveryTimer = null;
      function actualButton() {
        return Array.from(root.querySelectorAll('.product-form__submit')).find(function (button) {
          return button.getBoundingClientRect().width > 0;
        });
      }
      function personalizationPending() {
        return root.dataset.hadayaPersonalization === 'true' && !root.querySelector('.front_tbox textarea');
      }
      function refreshRecovery(pending) {
        var recovery = root.querySelector('.hdy-personalization-recovery');
        if (!recovery) return;
        if (!pending) {
          if (recoveryTimer !== null) clearTimeout(recoveryTimer);
          recoveryTimer = null;
          recovery.hidden = true;
        } else if (recoveryTimer === null && recovery.hidden) {
          recoveryTimer = setTimeout(function () {
            recoveryTimer = null;
            if (personalizationPending()) recovery.hidden = false;
          }, 20000);
        }
      }
      root.addEventListener('click', function (event) {
        var retry = event.target.closest('.hdy-options-retry');
        if (!retry || !personalizationPending()) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        window.location.reload();
      }, true);
      root.addEventListener('submit', function (event) {
        if (!personalizationPending()) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        var loading = root.querySelector('.hdy-personalization-placeholder');
        if (loading) loading.scrollIntoView({ block:'center', behavior:'instant' });
      }, true);
      function reveal(field) {
        if (back && back.contains(field)) backExpanded = true;
        refresh();
        field.scrollIntoView({ block:'center', behavior:'instant' });
        field.focus({ preventScroll:true });
      }
      function missingRequiredOption() {
        var options = root.querySelectorAll('.mw-option--required');
        for (var i = 0; i < options.length; i++) {
          var option = options[i];
          if (!option.getBoundingClientRect().height) continue;
          var controls = Array.from(option.querySelectorAll('.mw-option__control')).filter(function (field) { return !field.disabled; });
          if (!controls.length) continue;
          var grouped = controls[0].type === 'radio' || controls[0].type === 'checkbox';
          if (grouped ? !controls.some(function (field) { return field.checked; }) : !String(controls[0].value || '').trim()) return controls[0];
        }
        return null;
      }
      function refresh() {
        queued = false;
        var currentBack = root.querySelector('.back_tbox');
        if (currentBack && currentBack !== back) {
          if (toggle) toggle.remove();
          back = currentBack;
          toggle = document.createElement('button');
          toggle.type = 'button';
          toggle.className = 'hdy-back-toggle';
          toggle.setAttribute('aria-controls', back.id);
          back.before(toggle);
          toggle.addEventListener('click', function () {
            backExpanded = !backExpanded;
            refresh();
            if (backExpanded) back.querySelector('textarea').focus({ preventScroll:true });
          });
        }
        if (back) {
          var field = back.querySelector('textarea');
          if (field && (field.value || field.getAttribute('aria-invalid') === 'true')) backExpanded = true;
          if (typeof window.getSkylineSelected === 'function' && /back|both/.test(window.getSkylineSelected())) backExpanded = true;
          back.hidden = !backExpanded;
          toggle.setAttribute('aria-expanded', String(backExpanded));
          var label = backExpanded ? 'Back engraving' : '+ Add engraving on the back';
          if (toggle.textContent !== label) toggle.textContent = label;
        }
        var button = actualButton();
        var mobile = window.matchMedia('(max-width:1024px), (orientation:portrait)').matches;
        var keyboard = window.visualViewport && window.visualViewport.height < window.innerHeight * .75;
        var focusedInput = /INPUT|TEXTAREA|SELECT/.test(document.activeElement.tagName);
        var rect = button && button.getBoundingClientRect();
        sticky.hidden = !mobile || !button || document.body.classList.contains('show_menu') || keyboard || focusedInput || (rect.top >= 60 && rect.bottom <= window.innerHeight - 100);
        var pending = personalizationPending();
        refreshRecovery(pending);
        action.disabled = pending || root.dataset.hadayaProductAvailable === 'false' || (button && (button.getAttribute('aria-busy') === 'true' || button.getAttribute('aria-disabled') === 'true'));
        // The draft preview toolbar covers the bottom 64px; the live layout has no offset.
        sticky.style.setProperty('--hdy-preview-offset', document.getElementById('PBarNextFrame') ? '64px' : '0px');
      }
      function schedule() {
        if (queued) return;
        queued = true;
        requestAnimationFrame(refresh);
      }
      action.addEventListener('click', function () {
        if (personalizationPending()) return;
        if (typeof window.hadayaEngravingValidate === 'function' && !window.hadayaEngravingValidate()) {
          var invalid = root.querySelector('textarea[aria-invalid="true"]');
          if (invalid) reveal(invalid);
          return;
        }
        var button = actualButton();
        if (!button || button.disabled) return;
        var missing = missingRequiredOption();
        // Delegate to the visible app-managed control, preserving options, pricing and validation.
        button.click();
        setTimeout(function () {
          var invalid = root.querySelector('.mw-option--error input, .mw-option--error select, .mw-option--error textarea, [aria-invalid="true"]');
          if (missing) reveal(missing);
          else if (invalid) reveal(invalid);
          else button.scrollIntoView({ block:'center', behavior:'instant' });
        }, 100);
      });
      ['input','change','keyup'].forEach(function (name) { root.addEventListener(name, schedule); });
      ['scroll','resize','orientationchange','pageshow'].forEach(function (name) { window.addEventListener(name, schedule, { passive:true }); });
      document.addEventListener('focusin', schedule);
      document.addEventListener('focusout', schedule);
      new MutationObserver(schedule).observe(root, { childList:true, subtree:true, attributes:true, attributeFilter:['aria-invalid','aria-busy','aria-disabled'] });
      new MutationObserver(schedule).observe(document.body, { attributes:true, attributeFilter:['class'] });
      if (window.visualViewport) window.visualViewport.addEventListener('resize', schedule);
      refresh();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
